/* ClinicianCharts auto-generated by npm run generator */
import { Client, ModuleStatus, UserStatus } from "@qlarity/common"
import ChartContainer from "components/atoms/ChartContainer"
import { observer } from "mobx-react"
import React from "react"
import { Clinician } from "store/modules/Auth"
import LastActivityChart from "./LastActivityChart"
import ModuleCompletionChart from "./ModuleCompletionChart"
import ModuleUtilizationChart from "./ModuleUtilizationChart"
import MoodChart from "./MoodChart"

interface ClinicianChartsProps {
    clinician: Clinician
    clients?: Client[]
}

const ClinicianCharts: React.FC<ClinicianChartsProps> = ({ clinician, clients }) => {
    return (
        <ChartContainer title={`Client Use Statistics: ${clinician.displayName}`}>
            <ModuleCompletionChart clients={clients} />
            <LastActivityChart clients={clients} />
            <MoodChart checkins={clients?.filter((client) => client.status === UserStatus.ACTIVE).map((client) => client.checkins) ?? []} />
            <ModuleUtilizationChart clients={clients} type={ModuleStatus.TRAINING} />
            <ModuleUtilizationChart clients={clients} type={ModuleStatus.PRACTICE} />
        </ChartContainer>
    )
}

export default observer(ClinicianCharts)
